import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CobrancaPixPage } from '@/features/cobranca-pix/page/CobrancaPixPage';

export const Route = createFileRoute('/a/cobranca-pix/')({
    component: CobrancaPixPage,
    validateSearch: z.object({ tipo: z.enum(['instantaneo', 'cobranca']) }),
});
